import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import * as Api from './lib/api';
import { loc } from './lib/loc';
import { ErrorLoc } from './loc/error';
import LoginScreen from './screens/LoginScreen';
import Register from './screens/RegisterScreen';
import Personal from './screens/PersonalScreen';

import ChatBitrix24 from './components/ChatBitrix24';

function App() {
    document.scrollTop = 50;

    return (
        <div className="App">
            <Switch>
                <Route
                    path="/login/"
                    render={props => {
                        return Api.isAuth() ? <Redirect to="/" /> : <LoginScreen />;
                    }}
                />
                <Route
                    path="/register/"
                    render={props => {
                        return Api.isAuth() ? <Redirect to="/" /> : <Register />;
                    }}
                />
                <Route
                    path="/"
                    render={props => {
                        return Api.isAuth() ? (
                            <Personal />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: '/login/',
                                    state: {
                                        errorMessage: loc(ErrorLoc.permissionDenied),
                                        backUrl: window.location.pathname.replace('/' + process.env.REACT_APP_ROUTE_BASE, ''),
                                    },
                                }}
                            />
                        );
                    }}
                />
            </Switch>

            {Api.isAuth() && <ChatBitrix24 />}
        </div>
    );
}

export default withRouter(App);
